import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { getHostname, resolveRootLandingKey } from "@/lib/siteHosts";
import { getStoredLeadId } from "@/lib/leadIdCookie";
import MainLanding from "./main/MainLanding";
import MarketingAgency from "./MarketingAgency";
import RoofingCompany from "./RoofingCompany";
import RealEstate from "./RealEstate";
import StubLanding from "./stub/StubLanding";

const LANDING_BY_KEY = {
  main: MainLanding,
  partner: MarketingAgency,
  roofing: RoofingCompany,
  realEstate: RealEstate,
};

const RootLanding = () => {
  const [searchParams] = useSearchParams();
  const search = searchParams.toString() ? `?${searchParams.toString()}` : "";
  const key = resolveRootLandingKey(getHostname(), search, getStoredLeadId());

  if (key === "loginRedirect") {
    return <Navigate to="/login" replace />;
  }
  if (key === "stub") {
    return <StubLanding />;
  }

  const Component = LANDING_BY_KEY[key] ?? StubLanding;
  return <Component />;
};

export default RootLanding;
